import { styled, theme } from "@theme/stitches.config"
import { NewsLetterSignUpWrapper } from "@components/NewsletterSignUp/styles"
import * as Accordion from "@radix-ui/react-accordion"
import { accordionClose, accordionOpen } from "@components/styles"
import { ChevronDownIcon } from "@radix-ui/react-icons"

export const FaqWrapper = styled("div", {
    [`& + ${NewsLetterSignUpWrapper}`]: {
        paddingTop: "0 !important"
    },
    mt: 140,
    mb: 120,
    "@mdDown": {
        mt: 60,
        mb: 60
    }
})

export const FaqRow = styled("div", {
    display: "flex",
    flexWrap: "wrap"
})

export const LeftCol = styled("div", {
    maxWidth: "33.3333%",
    flex: "1 0 33.3333%",
    pr: 70,
    "@mdDown": {
        pr: 0,
        mb: 40,
        maxWidth: "100%",
        flex: "1 0 100%"
    }
})
export const RightCol = styled("div", {
    maxWidth: "66.6666%",
    flex: "1 0 66.6666%",
    pl: 60,
    "@lgDown": {
        pl: 0
    },
    "@mdDown": {
        maxWidth: "100%",
        flex: "1 0 100%"
    }
})

export const AccordionHeader = styled(Accordion.Header, ({
    cursor: "pointer",
    fontSize: theme.fontSizes.desktopLarge,
    mb: 20,
    span: {
        display: "flex",
        alignItems: "center",
        svg: {
            flexShrink: 0,
            ml: "auto"
        }
    }
}))

export const AccordionItem = styled(Accordion.Item, ({
    mb: 30,
    pb: 10,
    borderBottom: "1px solid rgba(255, 255, 255, 0.2)"
}))

export const AccordionContent = styled(Accordion.Content, {
    overflow: "hidden",
    div: {
        pb: 20
    },
    "&[data-state=\"open\"]": { animation: `${accordionOpen} 300ms ease-out` },
    "&[data-state=\"closed\"]": { animation: `${accordionClose} 300ms ease-out` }
})

export const StyledChevron = styled(ChevronDownIcon, {
    width: 20,
    height: 20,
    transition: "transform 300ms cubic-bezier(0.87, 0, 0.13, 1)",
    "[data-state=open] &": { transform: "rotate(180deg)" }
})
